import React, { useCallback, useContext } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useHistory, useParams, useLocation } from 'react-router-dom';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { useTheme } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import { PATH_DASHBOARD, PATH_JOB_CENTER, PATH_HOME, PATH_SUB_PAGE_TERMS, PATH_SUB_PAGE_PRIVACY, PATH_SUB_PAGE_FAQ, PATH_RESOURCE_CENTER } from '../../system/constants';
import { AppContext, LayoutContext } from '../../common/contexts';
import {
    DASHBOARD_MY_PROFILE,
    DASHBOARD_MY_CALENDAR,
    DASHBOARD_MY_JOBS,
    DASHBOARD_MY_SETTINGS,
    DASHBOARD_MY_MESSAGES,
    DASHBOARD_JOB_CENTER,
    BASE_URL,
    DASHBOARD_ID_MY_SETTINGS,
    DASHBOARD_ID_MY_PROFILE,
    DASHBOARD_ID_MY_JOBS,
    DASHBOARD_ID_MY_MESSAGES,
    DASHBOARD_ID_MY_CALENDAR,
    HOMEPAGE_ABOUT,
    HOMEPAGE_CONTACT,
    HOMEPAGE_FAQ,
} from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { getMyCalendarCaption } from '../../common/calendarHelper';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { isOnPage } from '../../system/helpers/systemHelper';
import { getCopyrightText } from '../../common/textHelper';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import NavigationButton from '../../dashboard/subComponents/NavigationButton';
import AfitdLink from '../../common/elemental/AfitdLink';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdBox from '../../common/elemental/AfitdBox';
import TopNavButton from './TopNavButton';

import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _keys from 'lodash/keys';
import _noop from 'lodash/noop';

const styles = theme => ({
    root: {
        backgroundColor: '#FAFAFC',
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    // footer style
    footerRoot: {
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        marginBottom: 24,
        marginTop: '25px',

        // added below lines
        [theme.breakpoints.down('md')]: {
            paddingTop: 24,
            flexDirection: 'row',
        },
    },
    footerLinks: {
        display: 'flex',
        justifyContent: 'center',
    },
    footerText: {
        fontSize: '13px',
        color: 'rgba(17, 30, 20, 0.4)',
    },
    separator: {
        fontSize: '13px',
        color: 'rgba(17, 30, 20, 0.4)',
        margin: '0 3px',
    },
    copyright: {
        textAlign: 'center',
        color: 'rgba(17, 30, 20, 0.4)',
        margin: '12px 0',
    },
    resourceCenterButtonContainer: { marginLeft: 0 /* 40 */ },
    resourceCenterButtonSection: {
        margin: 'auto',
    },
    NavigationButtonContainer: { borderTop: '1px solid #F0F2F6', paddingTop: 15 },
});

const getDefns = params => {
    const {
        props,
        profilePicUrl,
        // dashboard,
        // setCurrentDashboard,
        dashboardData,
        currentThreadId,
        handleClickJobCenterButton,
        history,
        pageId,
        location,
        preAccountSetup,
        setPendingAccountSetupMessageDialogOpen,
    } = params;
    const {
        classes,
        classes: { root: rootCls },
        handleDrawerClose,
    } = props;

    const unreadMessagesCounts = _get(dashboardData, 'unreadMsgsCounts');
    const threadIdList = _keys(unreadMessagesCounts);
    const unreadMessagesCount = _reduce(threadIdList, (total, threadId) => (threadId !== currentThreadId ? total + _get(unreadMessagesCounts, threadId, 0) : total), 0);

    const myCalendarCaption = getMyCalendarCaption({ dashboardData });
    const isOnJobCenterPage = isOnPage(location, PATH_JOB_CENTER);

    const defns = {
        root: {
            className: rootCls,
        },
        photoSection: {
            photoUrl: profilePicUrl,
        },
        myProfileButton: {
            label: DASHBOARD_MY_PROFILE,
            selected: pageId === DASHBOARD_ID_MY_PROFILE,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_PROFILE}`, handleDrawerClose),
        },
        myCalendarButton: {
            label: DASHBOARD_MY_CALENDAR,
            selected: pageId === DASHBOARD_ID_MY_CALENDAR,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_CALENDAR}`, handleDrawerClose),
            caption: myCalendarCaption,
        },
        myJobsButton: {
            label: DASHBOARD_MY_JOBS,
            selected: pageId === DASHBOARD_ID_MY_JOBS,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_JOBS}`, handleDrawerClose),
        },
        mySettingsButton: {
            label: DASHBOARD_MY_SETTINGS,
            selected: pageId === DASHBOARD_ID_MY_SETTINGS,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`, handleDrawerClose),
        },
        myMessagesButton: {
            label: DASHBOARD_MY_MESSAGES,
            selected: pageId === DASHBOARD_ID_MY_MESSAGES,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_MESSAGES}`, handleDrawerClose),
            caption: unreadMessagesCount,
        },
        jobCenterButton: {
            label: DASHBOARD_JOB_CENTER,
            selected: isOnJobCenterPage,
            onClick: handleClickJobCenterButton,
        },
        jobCenterClose: {
            onClick: () => handleDrawerClose,
        },
        copyright: {
            variant: 'caption',
        },

        aboutLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_ABOUT}`, handleDrawerClose),
        },
        contactUsLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_CONTACT}`, handleDrawerClose),
        },
        FAQLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_FAQ}`, handleDrawerClose),
        },
        termsOfUseLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_TERMS}`, handleDrawerClose),
        },
        privacyLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_PRIVACY}`, handleDrawerClose),
        },
        resourceCenterButton: {
            onClick: handleClickResourceCenterButton.bind(null, history, PATH_RESOURCE_CENTER, handleDrawerClose, preAccountSetup, setPendingAccountSetupMessageDialogOpen),
            label: 'Resource Center',
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickResourceCenterButton = (history, path, handleDrawerClose = _noop, preAccountSetup, setPendingAccountSetupMessageDialogOpen) => {
    if (preAccountSetup) {
        setPendingAccountSetupMessageDialogOpen(true);
    }
    history.push(`${BASE_URL}${path}`);
    handleDrawerClose();
};

const handleClickButton = (history, path, handleDrawerClose = _noop) => {
    history.push(`${BASE_URL}${path}`);
    handleDrawerClose();
};

const TopNavJsSmallMenu = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { currentUser, emailVerified, pendingAccountSetup, setPendingAccountSetupMessageDialogOpen } = appContext;
    const profilePicUrl = _get(currentUser, 'profilePicUrl');
    const context = useContext(LayoutContext);
    const { dashboard, setCurrentDashboard = _noop, dashboardData, currentThreadId } = context;
    const history = useHistory();
    const location = useLocation();
    const { pageId } = useParams();
    // const { handleDrawerClose } = props;

    // const theme = useTheme();
    // const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const preAccountSetup = !emailVerified || pendingAccountSetup;

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const handleClickJobCenterButton = useCallback(() => {
        history.push(`${BASE_URL}${PATH_JOB_CENTER}`);
    }, [history]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({
        props,
        profilePicUrl,
        dashboard,
        setCurrentDashboard,
        dashboardData,
        currentThreadId,
        handleClickJobCenterButton,
        history,
        pageId,
        location,
        preAccountSetup,
        setPendingAccountSetupMessageDialogOpen,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.resourceCenterButtonSection}>
                <AfitdBox {...defns.resourceCenterButtonContainer}>
                    <TopNavButton {...defns.resourceCenterButton} />
                </AfitdBox>
            </div>
            <div {...defns.NavigationButtonContainer}>
                <Grid container justify="center">
                    <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
                        <NavigationButton {...defns.myProfileButton} />
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
                        <NavigationButton {...defns.myCalendarButton} />
                    </Grid>
                </Grid>
                <Grid container justify="center">
                    <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
                        <NavigationButton {...defns.myJobsButton} />
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
                        <NavigationButton {...defns.myMessagesButton} />
                    </Grid>
                </Grid>
                <Grid container justify="center">
                    <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
                        <span {...defns.jobCenterClose}>
                            <NavigationButton {...defns.jobCenterButton} />
                        </span>
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
                        <NavigationButton {...defns.mySettingsButton} />
                    </Grid>
                </Grid>
            </div>

            {/* footer bottom */}
            <div {...defns.footerRoot}>
                <div {...defns.footerLinks}>
                    <AfitdLink {...defns.footerText}>
                        <span {...defns.aboutLink}>About Us</span>
                    </AfitdLink>
                    <div {...defns.separator}> / </div>
                    <AfitdLink {...defns.footerText}>
                        <span {...defns.termsOfUseLink}>Terms</span>
                    </AfitdLink>
                    <div {...defns.separator}> / </div>
                    <AfitdLink {...defns.footerText}>
                        <span {...defns.privacyLink}>Privacy</span>
                    </AfitdLink>
                    <div {...defns.separator}> / </div>
                    <AfitdLink {...defns.footerText}>
                        <span {...defns.contactUsLink}>Contact Us</span>
                    </AfitdLink>
                </div>
                <AfitdTypography {...defns.copyright}>{getCopyrightText({ variant: 'small' })}</AfitdTypography>
            </div>
        </div>
    );
};

export default withStyles(styles)(TopNavJsSmallMenu);
